import { queryOptions } from "@tanstack/react-query";
import instance from "./axiosInstance";
import { Company } from "types/company.type";

const ENDPOINT = "/error-notification-email";

export enum ErrorNotificationEmailQueryKey {
  GetList = "get-error-notification-email-list",
}

export type ErrorNotificationEmail = {
  id: number;
  email: string;
  company: Company;
};

export type CreateErrorNotificationEmailDto = {
  email: string;
};

export const getErrorNotificationEmails = () =>
  queryOptions({
    queryKey: [ErrorNotificationEmailQueryKey.GetList],
    queryFn: async (): Promise<ErrorNotificationEmail[]> =>
      (await instance.get(ENDPOINT)).data,
  });

export const createErrorNotificationEmail = () => ({
  mutationFn: async (
    data: CreateErrorNotificationEmailDto,
  ): Promise<ErrorNotificationEmail> =>
    (await instance.post(ENDPOINT, data)).data,
});

export const deleteErrorNotificationEmail = () => ({
  mutationFn: async (id: number): Promise<void> =>
    (await instance.delete(`${ENDPOINT}/${id}`)).data,
});
